import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../dashboard/components/TopNavBar';
import InventoryManagementTab from '../admin-dashboard/components/InventoryManagementTab';
import NavigationPreventer from '../../components/NavigationPreventer';
import { useAuth } from '../../state/auth/useAuth';

const InventoryPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('inventory');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    switch(tabId) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'master-data':
        navigate('/admin/dashboard');
        break;
      case 'patients':
        navigate('/users');
        break;
      case 'inventory':
        // Stay on inventory page
        break;
      case 'reports':
        navigate('/accounting');
        break;
      case 'finance':
        navigate('/finance');
        break;
      case 'settings':
        navigate('/hospital-settings');
        break;
      case 'profile':
        console.log('Profile navigation - route not yet configured');
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <NavigationPreventer />
      <TopNavBar 
        user={user}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <main className="pt-20 px-4 lg:px-6">
        <div className="space-y-6">
          {/* Header */}
          <div className="bg-white rounded-lg border shadow-sm p-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Inventory Management
            </h1>
            <p className="text-gray-600">
              Manage hospital inventory, stock levels, and supplies
            </p>
          </div>

          {/* Inventory Management Content */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="p-6">
              <InventoryManagementTab />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default InventoryPage;